"use strict";

var _regeneratorRuntime = require("/usr/src/app/www/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scheduledModelRun = exports.asyncModelRun = exports.modelRun = void 0;

var ScheduledCommand_1 = require("./commands/ScheduledCommand");

var genericModelRun = function genericModelRun(s, cmds, initialValue, runCmd, then) {
  return s.then(function (o) {
    var model = o.model,
        real = o.real;
    var state = initialValue;

    var _iterator = _createForOfIteratorHelper(cmds),
        _step;

    try {
      var _loop = function _loop() {
        var c = _step.value;
        state = then(state, function () {
          return runCmd(c, model, real);
        });
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return state;
  });
};

var internalModelRun = function internalModelRun(s, cmds) {
  var then = function then(_p, c) {
    return c();
  };

  var setupProducer = {
    then: function then(fun) {
      fun(s());
      return undefined;
    }
  };

  var runSync = function runSync(cmd, m, r) {
    if (cmd.check(m)) cmd.run(m, r);
    return undefined;
  };

  return genericModelRun(setupProducer, cmds, undefined, runSync, then);
};

var isAsyncSetup = function isAsyncSetup(s) {
  return typeof s.then === 'function';
};

var internalAsyncModelRun = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(s, cmds) {
    var defaultPromise,
        then,
        setupProducer,
        runAsync,
        _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            defaultPromise = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : Promise.resolve();

            then = function then(p, c) {
              return p.then(c);
            };

            setupProducer = {
              then: function then(fun) {
                var out = s();
                if (isAsyncSetup(out)) return out.then(fun);else return fun(out);
              }
            };

            runAsync = /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cmd, m, r) {
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return cmd.check(m);

                      case 2:
                        if (!_context.sent) {
                          _context.next = 5;
                          break;
                        }

                        _context.next = 5;
                        return cmd.run(m, r);

                      case 5:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function runAsync(_x3, _x4, _x5) {
                return _ref2.apply(this, arguments);
              };
            }();

            _context2.next = 6;
            return genericModelRun(setupProducer, cmds, defaultPromise, runAsync, then);

          case 6:
            return _context2.abrupt("return", _context2.sent);

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function internalAsyncModelRun(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

function modelRun(s, cmds) {
  internalModelRun(s, cmds);
}

exports.modelRun = modelRun;

function asyncModelRun(_x6, _x7) {
  return _asyncModelRun.apply(this, arguments);
}

function _asyncModelRun() {
  _asyncModelRun = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(s, cmds) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return internalAsyncModelRun(s, cmds);

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _asyncModelRun.apply(this, arguments);
}

exports.asyncModelRun = asyncModelRun;

function scheduledModelRun(_x8, _x9, _x10) {
  return _scheduledModelRun.apply(this, arguments);
}

function _scheduledModelRun() {
  _scheduledModelRun = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(scheduler, s, cmds) {
    var scheduledCommands, out;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            scheduledCommands = (0, ScheduledCommand_1.scheduleCommands)(scheduler, cmds);
            out = internalAsyncModelRun(s, scheduledCommands, scheduler.schedule(Promise.resolve(), 'startModel'));
            _context4.next = 4;
            return scheduler.waitAll();

          case 4:
            _context4.next = 6;
            return out;

          case 6:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _scheduledModelRun.apply(this, arguments);
}

exports.scheduledModelRun = scheduledModelRun;